// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media all and (min-width: 1300px) {
    .Popup2_wrap__fQvj7 {
        position: absolute;
        width: 100vw;
        height: 100%;
        z-index: 99997;
    }

    .Popup2_backWrap__XM9Pa {
        width: 100vw;
        height: 100%;
        z-index: 99998;
        top: 0;
        left: 0;
    }

    .Popup2_popupContainer__mYrjG {
        width: 500px;
        height: 491px;
        position: absolute;
        top: 30px;
        left: calc(3% + 500px);
        z-index: 99999;
    }

    .Popup2_popupHeader__wFNaT {
        width: 100%;
        height: 56px;
        background-color: #e50019;
        position: relative;
    }

    .Popup2_popupHeader__wFNaT > img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 16px;
        cursor: pointer;
    }

    .Popup2_popupBody__Q7dIJ {
        height: 100%;
        overflow: auto;
        padding: 20px;
        background-color: #fff;
    }

    .Popup2_popupBody__Q7dIJ .Popup2_popupCnt__4iejm {
        text-align: center;
        border-top: 1px solid #434343;
        border-bottom: 1px solid #434343;
        padding: 20px;
    }

    .Popup2_popupCnt__4iejm > h2 {
        font-size: 20px;
        font-weight: 700;
    }

    .Popup2_popupCnt__4iejm > img {
        width: 100%;
    }

    .Popup2_popupCnt__4iejm > p {
        margin-top: 60px;
        font-size: 16px;
        line-height: 1.5;
        font-weight: 400;
    }

    .Popup2_popupCnt__4iejm > div p{
        font-size: 14px;
        line-height: 1.5;
        font-weight: 400;
    }

    .Popup2_popupCnt__4iejm > div {
        width: 60%;
        margin: 40px auto;
    }

    .Popup2_popupCnt__4iejm > div address{
        font-style: normal;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.5;
    }

    .Popup2_popupFooter__xozWK {
        width: 100%;
        height: 40px;
        background-color: #F4F4F4;
    }

    .Popup2_popupFooter__xozWK > span {
        color: #6F6F6F;
        font-size: 14px;
        letter-spacing: -0.14px;
        display: block;
        text-align: right;
        padding-right: 24px;
        text-decoration: underline;
        cursor: pointer;
        line-height: 40px;
    }
}

@media all and (max-width: 1299px) {
    .Popup2_wrap__fQvj7 {
        position: absolute;
        width: 100vw;
        height: 100%;
        z-index: 99997;
    }

    .Popup2_backWrap__XM9Pa {
        width: 100vw;
        height: 100%;
        z-index: 99998;
        top: 0;
        left: 0;
    }

    .Popup2_popupContainer__mYrjG {
        width: 320px;
        height: 272px;
        position: absolute;
        top: calc(320px + 4%);
        left: calc(100vw / 2);
        transform: translateX(-50%);
        z-index: 99999;
    }

    .Popup2_popupHeader__wFNaT {
        width: 100%;
        height: 32px;
        background-color: #e50019;
        position: relative;
    }

    .Popup2_popupHeader__wFNaT > img {
        width: 15px;
        height: 15px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 12px;
        cursor: pointer;
    }

    .Popup2_popupBody__Q7dIJ {
        background-color: #fff;
        height: 100%;
        overflow: auto;
    }

    .Popup2_popupBody__Q7dIJ .Popup2_popupCnt__4iejm {
        text-align: center;
        padding: 10px;
    }

    .Popup2_popupCnt__4iejm > img {
        width: 100%;
    }

    .Popup2_popupCnt__4iejm > h2 {
        font-size: 16px;
        font-weight: 700;
    }

    .Popup2_popupCnt__4iejm > p {
        padding: 0 20px;
        margin-top: 30px;
        font-size: 12px;
    }

    .Popup2_popupCnt__4iejm > div p{
        font-size: 10px;
        line-height: 1.6;
    }

    .Popup2_popupCnt__4iejm > div {
        width: 60%;
        margin: 15px auto;
    }

    .Popup2_popupCnt__4iejm > div address{
        font-style: normal;
        font-size: 10px;
        font-weight: 400;
    }

    .Popup2_popupFooter__xozWK {
        width: 100%;
        height: 24px;
        background-color: #F4F4F4;
    }

    .Popup2_popupFooter__xozWK > span {
        color: #6F6F6F;
        font-size: 9px;
        letter-spacing: -0.09px;
        display: block;
        text-align: right;
        padding-right: 12px;
        text-decoration: underline;
        cursor: pointer;
        line-height: 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Popup2.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,cAAc;QACd,MAAM;QACN,OAAO;IACX;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,2BAA2B;QAC3B,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,6BAA6B;QAC7B,gCAAgC;QAChC,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,uBAAuB;QACvB,cAAc;QACd,iBAAiB;QACjB,mBAAmB;QACnB,0BAA0B;QAC1B,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,cAAc;QACd,MAAM;QACN,OAAO;IACX;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,qBAAqB;QACrB,qBAAqB;QACrB,2BAA2B;QAC3B,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,QAAQ;QACR,2BAA2B;QAC3B,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,cAAc;QACd,uBAAuB;QACvB,cAAc;QACd,iBAAiB;QACjB,mBAAmB;QACnB,0BAA0B;QAC1B,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":["@media all and (min-width: 1300px) {\n    .wrap {\n        position: absolute;\n        width: 100vw;\n        height: 100%;\n        z-index: 99997;\n    }\n\n    .backWrap {\n        width: 100vw;\n        height: 100%;\n        z-index: 99998;\n        top: 0;\n        left: 0;\n    }\n\n    .popupContainer {\n        width: 500px;\n        height: 491px;\n        position: absolute;\n        top: 30px;\n        left: calc(3% + 500px);\n        z-index: 99999;\n    }\n\n    .popupHeader {\n        width: 100%;\n        height: 56px;\n        background-color: #e50019;\n        position: relative;\n    }\n\n    .popupHeader > img {\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 16px;\n        cursor: pointer;\n    }\n\n    .popupBody {\n        height: 100%;\n        overflow: auto;\n        padding: 20px;\n        background-color: #fff;\n    }\n\n    .popupBody .popupCnt {\n        text-align: center;\n        border-top: 1px solid #434343;\n        border-bottom: 1px solid #434343;\n        padding: 20px;\n    }\n\n    .popupCnt > h2 {\n        font-size: 20px;\n        font-weight: 700;\n    }\n\n    .popupCnt > img {\n        width: 100%;\n    }\n\n    .popupCnt > p {\n        margin-top: 60px;\n        font-size: 16px;\n        line-height: 1.5;\n        font-weight: 400;\n    }\n\n    .popupCnt > div p{\n        font-size: 14px;\n        line-height: 1.5;\n        font-weight: 400;\n    }\n\n    .popupCnt > div {\n        width: 60%;\n        margin: 40px auto;\n    }\n\n    .popupCnt > div address{\n        font-style: normal;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 1.5;\n    }\n\n    .popupFooter {\n        width: 100%;\n        height: 40px;\n        background-color: #F4F4F4;\n    }\n\n    .popupFooter > span {\n        color: #6F6F6F;\n        font-size: 14px;\n        letter-spacing: -0.14px;\n        display: block;\n        text-align: right;\n        padding-right: 24px;\n        text-decoration: underline;\n        cursor: pointer;\n        line-height: 40px;\n    }\n}\n\n@media all and (max-width: 1299px) {\n    .wrap {\n        position: absolute;\n        width: 100vw;\n        height: 100%;\n        z-index: 99997;\n    }\n\n    .backWrap {\n        width: 100vw;\n        height: 100%;\n        z-index: 99998;\n        top: 0;\n        left: 0;\n    }\n\n    .popupContainer {\n        width: 320px;\n        height: 272px;\n        position: absolute;\n        top: calc(320px + 4%);\n        left: calc(100vw / 2);\n        transform: translateX(-50%);\n        z-index: 99999;\n    }\n\n    .popupHeader {\n        width: 100%;\n        height: 32px;\n        background-color: #e50019;\n        position: relative;\n    }\n\n    .popupHeader > img {\n        width: 15px;\n        height: 15px;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 12px;\n        cursor: pointer;\n    }\n\n    .popupBody {\n        background-color: #fff;\n        height: 100%;\n        overflow: auto;\n    }\n\n    .popupBody .popupCnt {\n        text-align: center;\n        padding: 10px;\n    }\n\n    .popupCnt > img {\n        width: 100%;\n    }\n\n    .popupCnt > h2 {\n        font-size: 16px;\n        font-weight: 700;\n    }\n\n    .popupCnt > p {\n        padding: 0 20px;\n        margin-top: 30px;\n        font-size: 12px;\n    }\n\n    .popupCnt > div p{\n        font-size: 10px;\n        line-height: 1.6;\n    }\n\n    .popupCnt > div {\n        width: 60%;\n        margin: 15px auto;\n    }\n\n    .popupCnt > div address{\n        font-style: normal;\n        font-size: 10px;\n        font-weight: 400;\n    }\n\n    .popupFooter {\n        width: 100%;\n        height: 24px;\n        background-color: #F4F4F4;\n    }\n\n    .popupFooter > span {\n        color: #6F6F6F;\n        font-size: 9px;\n        letter-spacing: -0.09px;\n        display: block;\n        text-align: right;\n        padding-right: 12px;\n        text-decoration: underline;\n        cursor: pointer;\n        line-height: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Popup2_wrap__fQvj7`,
	"backWrap": `Popup2_backWrap__XM9Pa`,
	"popupContainer": `Popup2_popupContainer__mYrjG`,
	"popupHeader": `Popup2_popupHeader__wFNaT`,
	"popupBody": `Popup2_popupBody__Q7dIJ`,
	"popupCnt": `Popup2_popupCnt__4iejm`,
	"popupFooter": `Popup2_popupFooter__xozWK`
};
export default ___CSS_LOADER_EXPORT___;
